import React, { useEffect, useState, useRef } from "react";
import LogoutUser from "../../../../common/snippet/logOut";
import Avatar from "../../../../common/element/Avatar";
import { Link, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { motion } from "framer-motion";
import { HiChevronDown } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../../../../redux/auth/authSelector";
import { getAdminProfile } from "../../../../redux/Setting/Settingsslice";
import { selectAdminProfileData } from "../../../../redux/Setting/Settingsselectors";

const UserDropdown = ({ className }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const apiUserData = useSelector(selectAdminProfileData);

  useEffect(() => {
    if (!apiUserData) {
      dispatch(getAdminProfile());
    }
  }, [dispatch, apiUserData]);

  console.log("UserDropdown - userData from Redux:", userData);

  // Sanitize URL — remove double slashes (except after protocol)
  const sanitizeImageUrl = (url) => {
    if (!url) return null;
    return url.replace(/([^:]\/)\/+/g, "$1");
  };

  // ✅ Extract real name, email, and avatar from userData safely
  const firstName =
    apiUserData?.first_name || userData?.user?.first_name || userData?.first_name || "User";
  const lastName =
    apiUserData?.last_name || userData?.user?.last_name || userData?.last_name || "";
  const email =
    apiUserData?.email || userData?.user?.email || userData?.email || "user@example.com";
  const avatar =
    sanitizeImageUrl(apiUserData?.profile_image) ||
    userData?.user?.avatar ||
    userData?.avatar ||
    "/assets/images/Dummy.jpg";

 

  // =========================
  // ✅ Toggle Dropdown
  // =========================
  const toggleDropdown = () => setIsOpen(!isOpen);

  // ✅ Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // ✅ Logout handler
  const logoutUser = () => {
    // alert("You have been logged out!");
    navigate("/login");
  };

  // ✅ Handle organization switch
  const handleOrgSwitch = (data) => {
    alert(`Switched to organisation: ${data.trading_name}`);
    if (data.org_function_type === "client") {
      navigate("/client/dashboard");
    } else if (data.org_function_type === "provider") {
      navigate("/provider/dashboard");
    } else {
      navigate("/worker/dashboard");
    }
    setIsOpen(false);
  };

  // =========================
  // ✅ Render Component
  // =========================
  return (
    <div className="relative" ref={dropdownRef}>
      {/* User Avatar - Clickable */}
      <div
        className={classNames(
          className,
          "flex items-center cursor-pointer ms-5"
        )}
        onClick={toggleDropdown}
      >
        <Avatar 
          size={40} 
          shape="circle" 
          src={avatar} 
          crossOrigin="anonymous" 
          referrerPolicy="no-referrer"
        >
          {firstName?.slice(0, 1)}
        </Avatar>
        <div className="ml-3 text-start">
          <div className="font-lato font-medium text-sm leading-[150%] text-[#344054]">
            {`${firstName} ${lastName}`}
          </div>
          <div className="font-lato font-normal text-sm leading-[18px] text-[#475467]">{email}</div>
        </div>
        <motion.span
          className="ml-3 text-xl"
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <HiChevronDown />
        </motion.span>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50"
        >
          <div className="p-2">
            {/* Profile */}
            <Link
              to="/setting?tab=profile"
              className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors"
              onClick={() => setIsOpen(false)}
            >
              <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_8130_37405)">
                  <path d="M8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM8 3.25C9.51875 3.25 10.75 4.48125 10.75 6C10.75 7.51875 9.51875 8.75 8 8.75C6.48125 8.75 5.25 7.51875 5.25 6C5.25 4.48125 6.48125 3.25 8 3.25ZM8 14C6.16562 14 4.52188 13.1687 3.42188 11.8687C4.00937 10.7625 5.15937 10 6.5 10C6.575 10 6.65 10.0125 6.72188 10.0344C7.12813 10.1656 7.55312 10.25 8 10.25C8.44688 10.25 8.875 10.1656 9.27812 10.0344C9.35 10.0125 9.425 10 9.5 10C10.8406 10 11.9906 10.7625 12.5781 11.8687C11.4781 13.1687 9.83438 14 8 14Z" fill="#FF8E1C" />
                </g>
                <defs>
                  <clipPath id="clip0_8130_37405">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg></span>
              <span className="font-lato font-medium text-sm leading-[150%] text-[#101828]">Profile</span>
            </Link>

            <div className="my-2 border-t border-gray-200"></div>

            {/* Settings */}
            <Link
              className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors"
              to="/setting?tab=security"
              onClick={() => setIsOpen(false)}
            >
              <span>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6051 5.71765L15.1382 4.90758C14.7433 4.22214 13.8681 3.98568 13.1817 4.37898V4.37898C12.855 4.57145 12.4651 4.62605 12.0981 4.53075C11.7311 4.43545 11.417 4.19808 11.2252 3.87097C11.1018 3.66305 11.0355 3.42623 11.033 3.18447V3.18447C11.0441 2.79686 10.8979 2.42124 10.6276 2.14319C10.3573 1.86514 9.98596 1.70834 9.59819 1.7085H8.65769C8.27779 1.70849 7.91355 1.85987 7.64556 2.12915C7.37758 2.39842 7.22794 2.76338 7.22977 3.14328V3.14328C7.21851 3.92763 6.57942 4.55755 5.79499 4.55747C5.55322 4.55496 5.3164 4.48865 5.10849 4.36525V4.36525C4.42211 3.97195 3.5469 4.20841 3.15197 4.89385L2.65082 5.71765C2.25637 6.40223 2.48961 7.27689 3.17256 7.67417V7.67417C3.61649 7.93047 3.88996 8.40413 3.88996 8.91673C3.88996 9.42934 3.61649 9.903 3.17256 10.1593V10.1593C2.49048 10.5539 2.25698 11.4264 2.65082 12.109V12.109L3.12451 12.9259C3.30955 13.2598 3.62001 13.5062 3.98721 13.6105C4.3544 13.7149 4.74804 13.6686 5.08103 13.482V13.482C5.40837 13.2909 5.79845 13.2386 6.16457 13.3366C6.53068 13.4346 6.84249 13.6747 7.03068 14.0037C7.15408 14.2116 7.22039 14.4484 7.2229 14.6902V14.6902C7.2229 15.4826 7.86528 16.125 8.65769 16.125H9.59819C10.3879 16.125 11.0292 15.4868 11.033 14.6971V14.6971C11.0311 14.316 11.1817 13.95 11.4512 13.6805C11.7207 13.411 12.0867 13.2604 12.4678 13.2623C12.7089 13.2687 12.9448 13.3348 13.1543 13.4545V13.4545C13.8388 13.8489 14.7135 13.6157 15.1108 12.9328V12.9328L15.6051 12.109C15.7964 11.7806 15.8489 11.3894 15.751 11.0222C15.653 10.655 15.4127 10.342 15.0833 10.1524V10.1524C14.7539 9.96291 14.5136 9.64987 14.4157 9.28265C14.3177 8.91542 14.3703 8.5243 14.5616 8.19591C14.686 7.97869 14.8661 7.79859 15.0833 7.67417V7.67417C15.7622 7.27711 15.9949 6.40756 15.6051 5.72451V5.72451V5.71765Z" stroke="#FF8E1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <circle cx="9.13141" cy="8.91657" r="1.97712" stroke="#FF8E1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg></span>
              <span className="font-lato font-medium text-sm leading-[150%] text-[#101828]">Settings</span>
            </Link>

            <div className="my-2 border-t border-gray-200"></div>

            {/* Logout */}
            <Link
              to="/login"
              onClick={(e) => {
                e.preventDefault();
                logoutUser();
              }}
              className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors"
            >
              <LogoutUser logOut={"dropdownLogout"} />
            </Link>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default UserDropdown;
